/* src/app/components/side-nav/side-nav.component.scss */
:host {
  display: contents;
  --side-nav-width: 21.5rem;
  --side-nav-card-bg: rgba(255, 255, 255, 0.72);
  --side-nav-card-border: rgba(13, 18, 24, 0.07);
  --side-nav-card-shadow: 0 2px 14px rgba(0, 0, 0, 0.06);
}
:host-context(body.dark) {
  --side-nav-card-bg: rgba(22, 28, 36, 0.78);
  --side-nav-card-border: rgba(255, 255, 255, 0.08);
  --side-nav-card-shadow: 0 2px 16px rgba(0, 0, 0, 0.28);
}
:host.side-nav-host--persistent {
  display: block;
  flex: 0 0 var(--side-nav-width);
  width: var(--side-nav-width);
  min-height: 100%;
  align-self: stretch;
}
body.side-nav-open {
  overflow: hidden;
}
.side-nav {
  position: fixed;
  inset: 0;
  z-index: 10050;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.32s cubic-bezier(0.22, 1, 0.36, 1);
}
.side-nav--open,
.side-nav--closing {
  pointer-events: auto;
}
.side-nav--open {
  opacity: 1;
}
.side-nav--closing {
  opacity: 0;
}
.side-nav__backdrop {
  position: absolute;
  inset: 0;
  background: transparent;
}
.side-nav--open:not(.side-nav--persistent) .side-nav__backdrop {
  background: rgba(0, 0, 0, 0.14);
}
:host-context(body.dark) .side-nav--open:not(.side-nav--persistent) .side-nav__backdrop {
  background: rgba(0, 0, 0, 0.38);
}
.side-nav__panel {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: min(90vw, var(--side-nav-width));
  padding: calc(0.75rem + env(safe-area-inset-top, 0px)) 0.85rem calc(0.85rem + env(safe-area-inset-bottom, 0px));
  background: var(--exme-overlay-atmosphere-background);
  border-right: 1px solid rgba(var(--ion-color-primary-rgb), 0.12);
  box-shadow: 6px 0 28px rgba(0, 0, 0, 0.14);
  overflow: hidden;
  transform: translateX(-104%);
  transition: transform 0.36s cubic-bezier(0.22, 1, 0.36, 1);
}
:host-context(body.dark) .side-nav__panel {
  box-shadow: 6px 0 32px rgba(0, 0, 0, 0.42);
}
@media (max-width: 450px) {
  .side-nav:not(.side-nav--persistent) .side-nav__panel {
    max-width: min(92vw, var(--side-nav-width));
    padding-inline: 0.75rem;
  }
}
.side-nav--open .side-nav__panel {
  transform: translateX(0);
}
.side-nav--closing .side-nav__panel {
  transform: translateX(-104%);
}
.side-nav__panel--dragging {
  transition: none !important;
}
.side-nav__header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-bottom: 1.1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(var(--ion-color-primary-rgb), 0.1);
}
.side-nav__logo {
  flex: 1;
  min-width: 0;
  max-width: 9rem;
}
.side-nav__logo svg {
  display: block;
  width: 100%;
  height: auto;
}
.side-nav__logo-path {
  fill: var(--ion-color-primary);
}
.side-nav__avatar-btn {
  position: relative;
  flex-shrink: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 0.15s ease;
}
.side-nav__avatar-btn:active {
  opacity: 0.78;
}
@media (hover: hover) {
  .side-nav__avatar-btn:hover {
    opacity: 0.88;
  }
}
.side-nav__avatar-ring {
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 2px solid rgba(var(--ion-color-primary-rgb), 0.35);
}
.side-nav__avatar-img {
  position: relative;
  display: block;
  width: 3.35rem;
  height: 3.35rem;
  border-radius: 50%;
  object-fit: cover;
}
.side-nav__login-btn {
  flex-shrink: 0;
  --padding-start: 0.85rem;
  --padding-end: 0.85rem;
  height: 2.5rem !important;
  font-size: 0.85rem !important;
  margin: 0;
}
.side-nav__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.side-nav__sheet {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.1rem 0;
}
.side-nav__row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  margin: 0;
  padding: 0.72rem 0.8rem;
  border: 1px solid var(--side-nav-card-border);
  border-radius: 14px;
  background: var(--side-nav-card-bg);
  box-shadow: var(--side-nav-card-shadow);
  text-align: left;
  cursor: pointer;
  font: inherit;
  color: inherit;
  -webkit-tap-highlight-color: transparent;
  transition:
    background 0.15s ease,
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.12s ease;
}
.side-nav__row--active {
  background: var(--side-nav-card-bg);
  border-color: var(--side-nav-card-border);
  box-shadow: var(--side-nav-card-shadow);
}
.side-nav__row:active {
  transform: scale(0.985);
}
@media (hover: hover) {
  .side-nav__row:not(.side-nav__row--active):hover {
    border-color: rgba(var(--ion-color-primary-rgb), 0.16);
    background: rgba(255, 255, 255, 0.82);
  }
  :host-context(body.dark) .side-nav__row:not(.side-nav__row--active):hover {
    background: rgba(30, 38, 48, 0.88);
  }
}
.side-nav__label {
  flex: 1;
  min-width: 0;
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.35;
  color: rgba(var(--ion-color-text-rgb), 0.86);
}
.side-nav__row--active .side-nav__label {
  color: var(--ion-color-primary);
}
.side-nav__row app-side-nav-icon {
  opacity: 0;
  transform: scale(0.68) translateX(-0.55rem);
  transition: opacity 0.34s cubic-bezier(0.22, 1, 0.36, 1), transform 0.4s cubic-bezier(0.34, 1.2, 0.64, 1);
  transition-delay: calc(0.12s + var(--side-nav-stagger-index, 0) * 0.055s);
}
.side-nav--open:not(.side-nav--persistent) .side-nav__row app-side-nav-icon,
.side-nav--closing:not(.side-nav--persistent) .side-nav__row app-side-nav-icon {
  opacity: 1;
  transform: scale(1) translateX(0);
}
.side-nav--persistent .side-nav__row app-side-nav-icon {
  opacity: 1;
  transform: none;
  transition: none;
}
.side-nav__panel--dragging .side-nav__row app-side-nav-icon {
  transition: none;
}
.side-nav__badge {
  flex-shrink: 0;
  min-width: 1.4rem;
  padding: 0.14rem 0.48rem;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.3;
  text-align: center;
  color: var(--ion-color-primary-contrast, #fff);
  border-radius: 999px;
  background:
    linear-gradient(
      145deg,
      var(--ion-color-primary),
      rgba(var(--ion-color-primary-rgb), 0.85));
  box-shadow: 0 2px 6px rgba(var(--ion-color-primary-rgb), 0.24);
}
@media (prefers-reduced-motion: reduce) {
  .side-nav,
  .side-nav__panel {
    transition: none;
  }
  .side-nav__row app-side-nav-icon {
    opacity: 1;
    transform: none;
    transition: none;
  }
  .side-nav__row:active {
    transform: none;
  }
}
.side-nav--persistent {
  position: static !important;
  inset: auto !important;
  z-index: auto !important;
  width: 100%;
  height: 100%;
  min-height: 100%;
  pointer-events: auto;
  opacity: 1;
  visibility: visible;
  transition: none;
}
.side-nav--persistent .side-nav__backdrop {
  display: none;
}
.side-nav--persistent .side-nav__panel {
  position: relative;
  top: auto;
  left: auto;
  bottom: auto;
  width: 100%;
  max-width: none;
  height: 100%;
  min-height: 100%;
  transform: none !important;
  box-shadow: none;
  border-right: 1px solid rgba(var(--ion-color-primary-rgb), 0.14);
}
/*# sourceMappingURL=side-nav.component.css.map */
